<template>
  <div class="footer-subscribe">
    <div class="footer-subscribe-title">{{$t("footer.subscribe.title")}}</div>
    <div class="footer-subscribe-addr">
      <i class="icon iconfont icon-joinus"></i>
      <a href="mailto:contact@nkn.org" target="_blank">contact@nkn.org</a>
    </div>
    <div class="footer-subscribe-input" v-if="emailFlag">
      <input
        type="text"
        :placeholder="$t('footer.subscribe.inputph')"
        class="subscribe-input"
        v-model="emailAddress"
      />
      <div class="subscribe-btn" @click="subScribe">{{$t("footer.subscribe.btn")}}</div>
    </div>
    <div class="footer-subscribe-success" v-if="!emailFlag">{{$t("footer.subscribe.success")}}</div>
    <!-- <div class="footer-subscribe-notice">
    {{$t("footer.subscribe.notice")}}
    </div>-->
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data: function() {
    return {
      emailAddress: "",
      emailFlag: true
    };
  },
  methods: {
    subScribe: function() {
      if (!this.emailAddress) {
        return;
      }
      this.emailFlag = false;
      $(
        `<img src="http://prewww.nkn.org/mailsub/dosub?email=+${this.emailAddress}" style="position:absolute;left: 0; top: 0;visibility: hidden;width: 0;height: 0"/>`
      )
        .appendTo($("body"))
        .on("error", function() {
          $(this).remove();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-subscribe {
  color: #fff;
  padding: 3rem 0;
  // flex-grow: 1;
  width: 365px;
  margin-left: 60px;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 1rem 0;
  }

  &-title {
    @include nkn-font-set(1.2rem, currentColor);
    @media screen and (max-width: 768px) {
      font-weight: 600;
    }
  }

  &-addr {
    @include nkn-font-set(0.9rem, #4eadf8, 600);
    padding-top: 0.8rem;
    @media screen and (max-width: 768px) {
      padding-top: 0.3rem;
    }
    i {
      margin-right: 4px !important;
      @include nkn-font-set(1rem, currentColor);
      vertical-align: middle;
    }
  }

  &-input {
    display: flex;
    width: 365px;
    margin-top: 1rem;
    font-size: 0;
    border-radius: 0.2rem;
    overflow: hidden;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .subscribe-input {
      border: none;
      outline: none;
      width: 100%;
      height: 52px;
      overflow: hidden;
      line-height: 52px;
      @include nkn-font-set(0.7rem, $common-color);
      text-align: left;
      padding-left: 0.7rem;
      background: #edf1f8;
      vertical-align: middle;

      @media screen and (max-width: 768px) {
        line-height: 32px;
        height: 32px;
      }

      &::placeholder {
        color: #aab1c6;
      }
    }

    .subscribe-btn {
      display: inline-block;
      width: 102px;
      line-height: 52px;
      @include nkn-font-set(0.7rem, #fff);
      text-align: center;
      cursor: pointer;
      background: #1791f2;
      vertical-align: middle;
      border-radius: 0 0.2rem 0.2rem 0;

      @media screen and (max-width: 768px) {
        line-height: 32px;
      }

      &:hover {
        background: #51b2ff;
      }

      &:active {
        background: #0180e4;
      }
    }
  }

  &-success {
    width: 304px;
    @include nkn-font-set(0.7rem, green);
    line-height: 52px;
    text-align: left;
  }

  &-notice {
    @include nkn-font-set(0.6rem, #8ea1c6);
    margin-top: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/nknFooterSubscribe.vue